export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#1E0500',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FAAB18',
  },
  {
    path: 'M172.288 329.216h252.416v55.296H236.288v95.744h165.376V532.48H236.288v162.304h-64zM467.712 430.08h55.296v36.864h1.536c17.408-26.112 39.424-44.032 81.408-44.032 32.256 0 62.464 13.824 74.24 44.032 19.456-27.136 44.544-44.032 82.944-44.032 55.808 0 88.576 24.576 88.576 89.088v182.784h-58.368V540.16c0-41.984-2.56-71.168-48.128-71.168-39.424 0-56.32 26.112-56.32 70.656v155.136h-58.368V524.8c0-36.352-11.264-55.808-46.592-55.808-30.208 0-57.856 24.576-57.856 68.608v157.184h-58.368z',
    fill: '#FAAB18',
  },
]
